/** @format */

import React, { useState } from 'react';
import '../css/FAQ.css';

import { FiChevronsUp } from 'react-icons/fi';

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <div className='faq'>
      <div className='faq-container container padding'>
        <div className='faq-intro'>
          <div className='faq-intro-subheading-wrapper'>
            <p className='faq-intro-subheading'>
              Las preguntas frecuentes
            </p>
          </div>
          <h2 className='faq-intro-heading'>
            ¿Tiene preguntas en mente?
          </h2>
          <p className='faq-intro-content'>
            Aquí encontraras algunas preguntas que pueden ayudarte a
            entender más nuestro entrenamiento si no aclaramos tus
            dudas comunícate con nosotros.
          </p>
        </div>
        <div className='faq-content'>
        <div className='faq-content-item'>
            <div
              className={`faq-content-item-head ${
                open === 9 ? 'open' : null
              }`}
              onClick={() => {
                setOpen(9);
              }}>
              <h3 className='faq-content-item-heading'>
              ¿Qué debo hacer después de pagar?
              </h3>
              <FiChevronsUp
                className={`faq-content-item-icon ${
                  open === 9 ? 'open' : null
                }`}
              />
            </div>
            <div
              className={`faq-content-item-content ${
                open === 9 ? 'open' : null
              }`}>
              Si realizaste el pago del curso, envía el comprobante a coordinacionacademica@libel.academy y recibirás el acceso al curso en las próximas 48 horas hábiles.
            </div>
          </div>
          <div className='faq-content-item'>
            <div
              className={`faq-content-item-head ${
                open === 1 ? 'open' : null
              }`}
              onClick={() => {
                setOpen(1);
              }}>
              <h3 className='faq-content-item-heading'>
                ¿Necesito conocimientos previos para este curso?
              </h3>
              <FiChevronsUp
                className={`faq-content-item-icon ${
                  open === 1 ? 'open' : null
                }`}
              />
            </div>
            <div
              className={`faq-content-item-content ${
                open === 1 ? 'open' : null
              }`}>
              No es necesario tener conocimientos previos, enseñaremos
              desde cero, paso a paso hasta llegar a un nivel básico.
            </div>
          </div>
          <div className='faq-content-item'>
            <div
              className={`faq-content-item-head ${
                open === 2 ? 'open' : null
              }`}
              onClick={() => {
                setOpen(2);
              }}>
              <h3 className='faq-content-item-heading'>
                ¿Dónde se ven las clases del curso?
              </h3>
              <FiChevronsUp
                className={`faq-content-item-icon ${
                  open === 2 ? 'open' : null
                }`}
              />
            </div>
            <div
              className={`faq-content-item-content ${
                open === 2 ? 'open' : null
              }`}>
              Las clases son en vídeo y puedes verlas en la plataforma de Libel Academy (Tu Perfil en la sección "Mi portal" - "Mis Cursos")
            </div>
          </div>
        </div>
        <div className='faq-content-item'>
          <div
            className={`faq-content-item-head ${
              open === 4 ? 'open' : null
            }`}
            onClick={() => {
              setOpen(4);
            }}>
            <h3 className='faq-content-item-heading'>
              ¿Qué conocimientos tendré al finalizar este curso?
            </h3>
            <FiChevronsUp
              className={`faq-content-item-icon ${
                open === 4 ? 'open' : null
              }`}
            />
          </div>
          <div
            className={`faq-content-item-content ${
              open === 4 ? 'open' : null
            }`}>
            Tendrás un conocimiento básico para crear modelos 3D en el
            software de Blender
          </div>
        </div>
        <div className='faq-content-item'>
          <div
            className={`faq-content-item-head ${
              open === 5 ? 'open' : null
            }`}
            onClick={() => {
              setOpen(5);
            }}>
            <h3 className='faq-content-item-heading'>
              ¿Por cuánto tiempo tendré el curso disponible en mi
              perfil?
            </h3>
            <FiChevronsUp
              className={`faq-content-item-icon ${
                open === 5 ? 'open' : null
              }`}
            />
          </div>
          <div
            className={`faq-content-item-content ${
              open === 5 ? 'open' : null
            }`}>
            Todo nuestro contenido lo tendrás por un año completo
            partiendo del momento que inicien las clases, por ello
            debes aprovechar los tiempos y cumplir las metas indicadas
            en el inicio del curso.
          </div>
        </div>

        <div className='faq-content-item'>
          <div
            className={`faq-content-item-head ${
              open === 6 ? 'open' : null
            }`}
            onClick={() => {
              setOpen(6);
            }}>
            <h3 className='faq-content-item-heading'>
              ¿Qué requisitos técnicos necesito?
            </h3>
            <FiChevronsUp
              className={`faq-content-item-icon ${
                open === 6 ? 'open' : null
              }`}
            />
          </div>
          <div
            className={`faq-content-item-content ${
              open === 6 ? 'open' : null
            }`}>
            Necesitas un computador de gama media Core i5 (o
            similares) de 7ma generación con 8 de Ram (como mínimo).
            Tarjeta de vídeo gt 1030 o gtx 1050. Mouse o tabla
            digitalizadora.
          </div>
        </div>

        <div className='faq-content-item'>
          <div
            className={`faq-content-item-head ${
              open === 7 ? 'open' : null
            }`}
            onClick={() => {
              setOpen(7);
            }}>
            <h3 className='faq-content-item-heading'>
              ¿Por qué elegir a Libel Academy?
            </h3>
            <FiChevronsUp
              className={`faq-content-item-icon ${
                open === 7 ? 'open' : null
              }`}
            />
          </div>
          <div
            className={`faq-content-item-content ${
              open === 7 ? 'open' : null
            }`}>
            <p>
              <b>Formación especializada:</b> Nuestros cursos son
              impartidos por maestros especialistas en el área de
              enseñanza.
            </p>
            <p>
              <b>Maestros con experiencia en la industria:</b>{' '}
              Nuestros maestros cuentan con una amplia experiencia,
              trabajando en proyectos de la industria real.
            </p>
            <p>
              <b>Resultados en corto tiempo:</b> Nuestros estudiantes
              han demostrado que con nuestra metodología es posible
              alcanzar en corto tiempo los conocimientos necesarios
              para trabajar en la industria.
            </p>
            <p>
              <b>Acompañamiento por parte de los maestros:</b>{' '}
              Nuestros maestros brindan asesoría a los estudiantes
              durante todo su proceso de aprendizaje, desde las pautas
              para iniciar hasta las correcciones del proyecto final.
            </p>
            <p>
              <b>
                Asesoría personalizada en la curva de aprendizaje:
              </b>{' '}
              Nuestro personal está capacitado para ofrecer a los
              estudiantes un contenido acorde con sus conocimientos y
              sus requerimientos. Las orientaciones se realizan de
              forma personalizada y gratuita.
            </p>
          </div>
        </div>

        <div className='faq-content-item'>
          <div
            className={`faq-content-item-head ${
              open === 8 ? 'open' : null
            }`}
            onClick={() => {
              setOpen(8);
            }}>
            <h3 className='faq-content-item-heading'>
              ¿Entregan certificado del curso?
            </h3>
            <FiChevronsUp
              className={`faq-content-item-icon ${
                open === 8 ? 'open' : null
              }`}
            />
          </div>
          <div
            className={`faq-content-item-content ${
              open === 8 ? 'open' : null
            }`}>
            Libel Academy entregará un certificado de cumplimiento de
            metas, siempre y cuando envíes tus resultados finales del
            curso y el maestro los apruebe.
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
